import React, { JSX } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";

import Login from "./routes/Login";
import Profile from "./routes/Profile";
import Admin from "./routes/Admin";
import { Provider } from "react-redux";
import { store } from "./store";
import { useAppSelector } from "./hooks";
import CreateParfume from "./routes/CreateParfume";
import EditParfume from "./routes/EditParfume";
import FormulasPage from "./routes/Admin/Formula";
import ProductionPage from "./routes/Admin/Production";
import PackPage from "./routes/Admin/Pack";
import DeliveryPage from "./routes/Admin/Delivery";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

function RequireAuth({ children, role }: { children: JSX.Element; role: "admin" | "client" }) {
  const { token, role: myRole } = useAppSelector(s => s.auth);

  if (!token || !myRole) {
    return <Navigate to="/login" replace />;
  }

  if (myRole !== role) {
    return myRole === "admin" ? <Navigate to="/admin" replace /> : <Navigate to="/profile" replace />;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />

        <Route
          path="/profile"
          element={
            <RequireAuth role="client">
              <Profile />
            </RequireAuth>
          }
        />
        <Route
          path="/create"
          element={
            <RequireAuth role="client">
              <CreateParfume />
            </RequireAuth>
          }
        />

        <Route
          path="/edit/:parfumeId"
          element={
            <RequireAuth role="client">
              <EditParfume />
            </RequireAuth>
          }
        />

        <Route
          path="/admin"
          element={
            <RequireAuth role="admin">
              <Admin />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/formulas"
          element={
            <RequireAuth role="admin">
              <FormulasPage />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/production"
          element={
            <RequireAuth role="admin">
              <ProductionPage />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/pack"
          element={
            <RequireAuth role="admin">
              <PackPage />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/shipping"
          element={
            <RequireAuth role="admin">
              <DeliveryPage />
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}


root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
